import { render } from "./Catalog-item.vue?vue&type=template&id=736ff0c9&scoped=true"
import script from "./Catalog-item.vue?vue&type=script&lang=js"
export * from "./Catalog-item.vue?vue&type=script&lang=js"

import "./Catalog-item.vue?vue&type=style&index=0&id=736ff0c9&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736ff0c9"]])

export default __exports__